module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jWpvl"))).then(() => parcelRequire('hEqeo'));